const datatypes = [
  "CSV",
  "DATABASE",
  "DELIMITED",
  "DELIM_FLD_ID",
  "MULIT_DELIMITED",
  "EDI",
  "EXCEL",
  "FIXED_LENGTH",
  "HL7",
  "JSON",
  "NVP",
  "SERVLET",
  "XML"
];
export const outboundDatatypes = [
  "CSV",
  "DATABASE",
  "DELIMITED",
  "DELIM_FLD_ID",
  "MULIT_DELIMITED",
  "EDI",
  "FIXED_LENGTH",
  "GraphQL",
  "HL7",
  "JSON",
  "SERVLET",
  "XML"
];
export default datatypes;

// Objects for identyfing Node types in Right Tree 
export const RECORD_TYPE = {
  RECORD: {type:"RECORD",icon:"RECORD",data:{}},
  ELEMENT: {type:"ELEMENT",icon:"ELEMENT",data:{}},
  REPEATING_ELEMENT: {type:"REPEATING_ELEMENT",icon:"REPEATING_ELEMENT",data:{}},
  RECORD_TOP: {type:"RECORD_TOP",icon:"RECORD_TOP",data:{}},
  QUERY: {type:"QUERY",icon:"QUERY",data:{QUERY: {QUERY_TYPE: "SELECT"}}},
  //CONDITION_ELSE: {type:"ELSE",icon:"CONDITION_ELSE",data:{}},
  RECORD_LOOP: {type:"RECORD_LOOP",icon:"RECORD_LOOP",data:{}},
};

export const FIELD_TYPE = {
  FIELD: {type:"Field",icon:"FIELD",data:{}, label: 'LBL_FIELD'},
  DATABASE_FIELD:{type:"Field",icon:"DATABASE_FIELD",data:{}, label: 'LBL_FIELD'},
  FIELD_LOOP:{type:"Field",icon:"FIELD_LOOP",data:{}, label: 'LBL_FIELD'},
  ATTRIBUTE:{type:'ATTRIBUTE', icon:'ATTRIBUTE', data:{}, label: ''},
};

export const ELEMENT_TYPE = {
  ELEMENT: {type: 'Element', icon: 'ELEMENT', data: {}}
}

export const OTHER_TYPE = {
  COMMENT: {type:"COMMENT",data:{}},
  FIELD_GROUP: {type:'FIELD_GROUP',icon:"FIELD_GROUP",data:{}},
  REPEATING_FIELD_GROUP: {type:'REPEATING_FIELD_GROUP',icon:"REPEATING_FIELD_GROUP",data:{}}
};

export const OUTBOUND_OTHER_TYPE = {
  CONDITION_IF: {type:'CONDITION_IF',icon:"CONDITION_IF",data:{}},
  CONDITION_ELSE: {type:'CONDITION_ELSE',icon:"CONDITION_ELSE",data:{}},
  VARIABLE: {type:'VARIABLE',icon:"VARIABLE",data:{}},
  VARIABLE_COLLECTION: {type:'VARIABLE_COLLECTION',icon:"VARIABLE_COLLECTION",data:{}},
  SEQUENCE: {type:'SEQUENCE',icon:"SEQUENCE",data:{}},
  QUERY: {type:'QUERY',icon:"QUERY",data:{}},
  PLUGIN: {type:'PLUGIN',icon:"PLUGIN",data:{}},
  ACTION_ITEM: {type:'ACTION_ITEM',icon:"ACTION_ITEM",data:{}},
  TRACKING_REPORT_ITEM: {type:'TRACKING_REPORT_ITEM',icon:"TRACKING_REPORT_ITEM",data:{}},
}

export const DATA_TYPE = {
  CSV: {record:RECORD_TYPE.RECORD,field:FIELD_TYPE.FIELD},
  DATABASE: {record:RECORD_TYPE.QUERY,field:FIELD_TYPE.DATABASE_FIELD},
  DELIMITED: {record:RECORD_TYPE.RECORD,field:FIELD_TYPE.FIELD},
  EXCEL: {record:RECORD_TYPE.RECORD,field:FIELD_TYPE.FIELD},
  FIXED_LENGTH: {record:RECORD_TYPE.RECORD,field:FIELD_TYPE.FIELD},
  NVP: {record:RECORD_TYPE.RECORD,field:FIELD_TYPE.FIELD},
  SERVLET: {record:RECORD_TYPE.RECORD,field:FIELD_TYPE.FIELD},
  JSON: {record:RECORD_TYPE.RECORD,field:FIELD_TYPE.FIELD},
  HL7: {record:RECORD_TYPE.RECORD,field:FIELD_TYPE.FIELD},
  DELIM_FLD_ID: {record:RECORD_TYPE.RECORD,field:FIELD_TYPE.FIELD},
  MULIT_DELIMITED: {record:RECORD_TYPE.RECORD,field:FIELD_TYPE.FIELD},
  EDI: {record:RECORD_TYPE.RECORD,field:FIELD_TYPE.FIELD},
  XML: {record:RECORD_TYPE.ELEMENT,field:FIELD_TYPE.ATTRIBUTE},
  GraphQL: {record:RECORD_TYPE.RECORD, field: FIELD_TYPE.FIELD},
};